module.exports = __webpack_public_path__ + "static/scale-model-of-clearwater-beach-tampa-in-clearwater-florida-dc772643c76137615ed3c09925e718da.png";